import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Belief from '../components/Belief';
import DXOCAlarmMessage from './components/DXOCAlarmMessage';
import Explanation from './components/Explanation';
import Helpfulness from './components/Helpfulness';
import OtherMatches from './components/OtherMatches';
import RichEndings from '../components/RichEndings';
import TreatmentPlan from '../../TreatmentPlan';
import { TREATMENT_PLAN_FEATURE_FLAG } from '../../TreatmentPlan/constants';
import { IS_LOCAL } from 'src/interviews/requests/settings';

import useInterview from 'src/interviews/hooks/useInterview';
import useInterviewType from 'src/interviews/hooks/useInterviewType';
import useFeatureFlag from 'src/hooks/useFeatureFlag';

import type { IInterviewResults } from 'src/packages/polaris/types';

const DiagnosisOfConcernCompletion = ({
  conditionName,
  result,
}: {
  conditionName: string;
  result: IInterviewResults;
}) => {
  const { token: interviewToken } = useInterview();
  const interviewType = useInterviewType();
  const dxocMatchDifferential = result.differential.find((dx) => dx.is_dxoc_match);
  const treatmentPlanFlagEnabled = useFeatureFlag({
    flagName: TREATMENT_PLAN_FEATURE_FLAG,
    defaultValue: IS_LOCAL,
  });

  // If available, use this name for better accuracy as to what the quiz was asking about
  const dxocName = result?.diagnosis_of_concern?.name || conditionName;

  return (
    <Grid item className="bp-w-full">
      <Grid container direction="column" spacing={2} paddingBottom={2}>
        <Belief conditionName={dxocName} result={result} />
        <DXOCAlarmMessage result={result} />
        <Explanation result={result} conditionName={dxocName} />
        {dxocMatchDifferential && treatmentPlanFlagEnabled && (
          <Grid item>
            <Card elevation={0}>
              <TreatmentPlan differential={dxocMatchDifferential} />
            </Card>
          </Grid>
        )}
        <Helpfulness result={result} />
        <OtherMatches
          result={result}
          interviewToken={interviewToken || ''}
          interviewType={interviewType}
        />
      </Grid>
      <RichEndings interviewType="dxoc" result={result} />
    </Grid>
  );
};

export default DiagnosisOfConcernCompletion;
